export default __webpack_public_path__ + "static/media/Open API Integration.480159d3.md";